import { Shield, Globe, Zap, Clock, CreditCard, Lock, BarChart3, Smartphone, Users, CheckCircle, DollarSign, TrendingUp } from 'lucide-react';

export default function Features() {
    const features = [
        {
            icon: Shield,
            title: 'Secure Payment Processing',
            description: 'Bank-level encryption and advanced fraud detection systems protect every transaction. Your money and data are always safe with our multi-layered security approach.'
        },
        {
            icon: Globe,
            title: 'Multi-Currency Support',
            description: 'Send and receive money in multiple currencies with competitive exchange rates. Support for USD, EUR, ETB, and more.'
        },
        {
            icon: Lock,
            title: 'Fraud Detection',
            description: 'Advanced AI-powered fraud detection monitors transactions in real-time to prevent unauthorized access and suspicious activities.'
        },
        {
            icon: Zap,
            title: 'Easy Integration',
            description: 'Simple and intuitive mobile app with seamless user experience. Get started in minutes with our easy onboarding process.'
        },
        {
            icon: BarChart3,
            title: 'Real-time Analytics',
            description: 'Track your transactions with detailed analytics and reports. Monitor your sending history and patterns with comprehensive dashboards.'
        },
        {
            icon: Clock,
            title: '24/7 Support',
            description: 'Our dedicated customer support team is available around the clock to assist you with any questions or concerns.'
        },
        {
            icon: CreditCard,
            title: 'Multiple Payment Methods',
            description: 'Pay with bank transfers, debit cards, or mobile wallets. Choose the payment method that works best for you.'
        },
        {
            icon: Smartphone,
            title: 'Mobile-First Design',
            description: 'Fully optimized mobile app for iOS and Android. Send money on the go with our intuitive mobile experience.'
        },
        {
            icon: Users,
            title: 'Merchant Network',
            description: 'Access to a growing network of trusted merchants and partner banks across Ethiopia for convenient cash pickup.'
        },
        {
            icon: CheckCircle,
            title: 'Instant Notifications',
            description: 'Receive real-time SMS and email notifications for every transaction to stay informed about your money transfers.'
        },
        {
            icon: DollarSign,
            title: 'Competitive Rates',
            description: 'Enjoy some of the best exchange rates in the market with transparent pricing and no hidden fees.'
        },
        {
            icon: TrendingUp,
            title: 'Rate Tracking',
            description: 'Monitor exchange rate trends over time and set alerts for favorable rates to maximize your transfers.'
        }
    ];

    return (
        <div className="min-h-screen pt-24 pb-20">
            <section className="bg-gradient-to-br from-emerald-800 to-emerald-900 text-white py-20">
                <div className="container mx-auto px-4">
                    <div className="max-w-3xl mx-auto text-center">
                        <h1 className="text-5xl font-bold mb-6">
                            Powerful Features for Your Money Transfers
                        </h1>
                        <p className="text-xl text-emerald-50">
                            Everything you need to send money securely, quickly, and affordably to your loved ones in Ethiopia.
                        </p>
                    </div>
                </div>
            </section>

            <section className="py-20 bg-gray-50">
                <div className="container mx-auto px-4">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {features.map((feature, index) => {
                            const Icon = feature.icon;
                            return (
                                <div
                                    key={index}
                                    className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition transform hover:scale-105"
                                >
                                    <div className="bg-emerald-100 w-16 h-16 rounded-full flex items-center justify-center mb-6">
                                        <Icon className="w-8 h-8 text-emerald-800" />
                                    </div>
                                    <h3 className="text-2xl font-bold text-emerald-900 mb-4">{feature.title}</h3>
                                    <p className="text-gray-600 leading-relaxed">{feature.description}</p>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </section>

            <section className="py-20 bg-white">
                <div className="container mx-auto px-4">
                    <div className="max-w-4xl mx-auto">
                        <div className="bg-gradient-to-br from-emerald-800 to-emerald-900 text-white p-12 rounded-2xl shadow-2xl text-center">
                            <h2 className="text-4xl font-bold mb-6">Ready to Experience These Features?</h2>
                            <p className="text-xl text-emerald-50 mb-8">
                                Download the Mojo Money app today and start sending money with confidence.
                            </p>
                            <div className="flex flex-col sm:flex-row gap-4 justify-center">
                                <button className="bg-yellow-500 text-emerald-900 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-yellow-400 transition transform hover:scale-105">
                                    Download on App Store
                                </button>
                                <button className="bg-white text-emerald-900 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-emerald-50 transition transform hover:scale-105">
                                    Get it on Google Play
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}
